<template>
  <div @click.stop class="the-mb-nav bg-theme-sec pb-2 anim-slide-in">
    <div class="mb-4 pc-none">
      <TopnavMainnav/>
    </div>

    <div class="mb-4 pc-none" style="margin-left: 40px;">
      <TopnavAccountBtn/>
    </div>

    <div class="mb-4" style="margin-left: 30px;">
      <HeaderLangSelect class="ml-auto"/>
    </div>

    <div>
      <!-- <router-link
        @click.native="hideMainnav()"
        class="nav-link-item"
        :to="{name: 'my'}"
        >
        <i class="fas fa-home op4 mx-2"></i>
        {{lg('',{
          en: 'My Stable',
          zh: '',
        })}}
      </router-link> -->

      <!-- <router-link
        @click.native="hideMainnav()"
        class="nav-link-item"
        :to="{name: 'setting'}"
        >
        <i class="fas fa-cog op4 mx-2"></i>
        {{lg('',{
          en: 'setting',
          zh: '',
        })}}
      </router-link> -->
    </div>

    <!-- <div>
      <TopnavThemeBtn class="ml-auto"/>
    </div> -->
  </div>
</template>

<script>
import bus from '@/bus.js'

export default {
  name: 'mbNav',
  components: {},
  props: [],
  data() {
    
    return {

    }
  },
  computed: {},
  watch: {},
  methods: {
    hideMainnav(){
      bus.topnavvue.dropnavOpen = false
    },
  },
  created() {
    return
  },
  mounted() {
    
  },
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .the-mb-nav{
    position: absolute;
    top: 50px;
    right: 0;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    z-index: 9;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    width: 200px;

    .nav-link-item{
      display: block;
      padding: 10px 20px;
      margin: 10px;
      background-color: rgba(150,150,150,0.16);
      border-radius: 4px;
      &:hover{
        background-color: rgba(150,150,150,0.2);
      }
    }
  }
</style>